export function pluralize(i18n, count) {
  if (count === 0) {
    return i18n.zero;
  } else if (count === 1) {
    return i18n.one;
  } else {
    return i18n.other.replace("%{count}", count);
  }
}
